<template>
    <div>
        <p class=" font-poppins font-bold text-blue-500 w-1/4 text-center m-auto text-2xl lg:w-full">Start Now in Four Easy Steps</p>
           
           <div class=" mt-20">
               <div class=" w-1/2 m-auto md:w-full md:p-4">
                    <div class=" relative">
                        <div class="flex w-1/3 shadow-2xl p-4 md:w-full rounded-lg">
                            <div>
                                <div class=" flex justify-between">
                                    <p class="font-poppins font-semibold text-xl">Sign Up</p>
                                       <i class=" fa fa-user border p-4 bg-gray-200 text-blue-700 rounded-xl"></i>
                                </div>
                                <div class=" text-sm mt-4">
                                    <p> Fill in required details to open user account on our CarryGo App </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <img class=" absolute bottom-5 left-1/2 md:hidden " src="../Images/strokeVector1.png" alt="image1">  
                        </div>
                        <!-- <div class="hidden text-blue-400 mt-5 mb-5 w-1/2 m-auto md:block ">
                            <i class="fa fa-arrow-down "></i>
                        </div> -->
                    </div>
                   
                    <div class="md:mt-4">
                        <div class=" flex justify-end">
                            <div class=" w-1/3 shadow-2xl p-4 md:w-full rounded-lg lg:mt-4 ">
                                <div class=" flex justify-between">
                                    <p class="font-poppins font-semibold text-xl">Create Order</p>
                                    <i class=" fa fa-edit border p-4  bg-gray-200 text-blue-700 rounded-xl"></i>
                                </div>
                                <div class=" text-sm mt-4">
                                    <p>
                                        This feature allows you to conveniently initiate a 
                                        pickup or delivery request on the CarryGo App from anywhere you are. 
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                   
                    <div class=" relative md:mt-4">
                        <div class=" flex justify-start">
                            <div>
                                <!-- <div class="hidden mt-5 mb-5 text-blue-400 w-1/2 m-auto md:block ">
                                    <i class="fa fa-arrow-down "></i>
                                </div> -->
                                <div class=" w-1/3 shadow-2xl p-4 md:w-full rounded-lg lg:mt-4">
                                    <div class=" flex justify-between">
                                        <p class=" font-poppins font-semibold text-xl">Track Order</p>
                                       <i class=" fa fa-mobile fa-2x border p-4  bg-gray-200 text-blue-700 rounded-xl"></i>
                                    </div>
                                    
                                    <div class=" text-sm mt-6">
                                        <p>
                                            Enables you to follow up on the progress of your delivery and the location  of your package until delivery.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div>
                            <img class=" absolute top-0 right-1/3 md:hidden" src="../Images/strokeVector2.png" alt="image1">  
                        </div>
                        <!-- <div class="hidden text-blue-400 mt-5 mb-5 w-1/2 m-auto md:block ">
                            <i class="fa fa-arrow-down "></i>
                        </div> -->
                    </div>
                   
                    <div class=" relative md:mt-4">
                        <div>
                            <img class=" absolute right-1/3  md:hidden" src="../Images/strokeVector1.png" alt="image1">  
                        </div>

                        <div class=" flex justify-end">
                            <div class=" w-1/3 shadow-2xl p-4 md:w-full rounded-lg lg:mt-4">
                                <div class=" flex justify-between">
                                    <p class="font-poppins font-semibold text-xl">Receive Order</p>
                                       <i class=" fa fa-gift border p-4  bg-gray-200 text-blue-700 rounded-xl"></i>
                                </div>
                                
                                <div class=" text-sm mt-4">
                                    <p>
                                        This is for CG Carriers and DSO Carriers to accept client pickup request and respond immediately. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

               </div>

               <div class=" w-1/6 m-auto mb-10 font-poppins mt-20 lg:w-1/2">
                   <a href="#downloadApp"><p class=" bg-blue-800 p-4 cursor-pointer text-white rounded-2xl text-center text-xl font-medium">GET STARTED</p></a>
               </div>
           </div>

        <div>
            <ComingSoonModal 
            v-show="isModalVisible"
            @click="close"
            />
        </div>
    </div>
</template>

<script>
import ComingSoonModal from '../ComingSoonModal.vue';
export default {
    components:{ComingSoonModal},
    data() {
        return {
            isModalVisible: false
        }
    },

    methods: {
        close() {
            this.isModalVisible = false;
        },

        downloadApp() {
            this.isModalVisible = true;
        }
    }    
}
</script>
<!-- "https://play.google.com/store/apps/details?id=com.carrygo.userapp" -->